<template>
	<div class="page-shop-manage">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">澳門門店</div>
			<div class="breadcrumb-item">店櫃管理</div>
		</div>
		
		<div class="card-block">
			
			<Form inline class="pg-form-inline form-input-wrap">
				<FormItem>
					<label class="input-label">
						<!-- <em class="red">* </em> -->
						<span>店櫃名稱</span>
					</label>
					<Input size="small" v-model="form.keywords" @keyup.enter.native="handleSearch"/>
				</FormItem>
				
				<FormItem>
					<label class="input-label">
						<!-- <em class="red">* </em> -->
						<span>好物對換</span>
					</label>
					<Select size="small" placeholder="全部" v-model="form.is_shop" clearable>
						<Option :value="1">是</Option>
						<Option :value="0">否</Option>
					</Select>
				</FormItem>
				<FormItem>
					<div class="pg-btn-wrap">
						<div class="pg-btn style2" @click="handleSearch">搜索</div>
					</div>
				</FormItem>
			</Form>
		</div>
		
		<div class="card-block pd-bt">
			<div class="pg-toolbar">
				<div class="pg-btn-wrap">
					<div class="pg-btn style1" @click="handleToAdd">新增店櫃</div>
				</div>
			</div>
			
			<Spin fix class="pg-sub-loading" v-if="isLoading">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>
			
			<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
				<el-tab-pane v-for="(item, index) in samecityList" :name="String(item.id)" :key="item.id"
				             :label="item.name"></el-tab-pane>
				
				<Table size="small"
				       border
				       no-data-text="暫無數據"
				       :columns="table.column"
				       :data="table.data">
					<template slot-scope="{ row, index }" slot="action">
						<div class="pg-btn-wrap">
							<div class="pg-btn style2" @click="handleEdit(index)" v-if="row.deleted_at == '- - -'">修改</div>
							<div class="pg-btn style1" @click="handleDelete(index)" v-if="row.deleted_at == '- - -'">刪除</div>
							<div class="pg-btn style3" @click="handleRestore(index)" v-if="row.deleted_at != '- - -'">還原</div>
						</div>
					</template>
				</Table>
				
				<div class="pg-pagger">
					<Row>
						<Col span="12" class="pagger-left">
							<div class="pagger-total">總共{{ totalCount }}條記錄</div>
						</Col>
						<Col span="12" class="pagger-right">
							<!-- v-if="totalCount > curPageSize" -->
							<div>
								<div class="pagger-sizer">
									<span>每頁</span>
									<Select v-model="curPageSize" size="small" placeholder="數量"
									        @on-change="handlePageSizeChange">
										<Option :value="10">10</Option>
										<Option :value="20">20</Option>
										<Option :value="30">30</Option>
										<Option :value="40">40</Option>
										<Option :value="50">50</Option>
									</Select>
								</div>
								
								<div class="pagger-elevator">
									<span>跳轉</span>
									<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
									       @on-enter="handlePageEnter"/>
								</div>
								
								<Page size="small"
								      :current="pageIndex"
								      :page-size="curPageSize"
								      :total="totalCount"
								      @on-change="handlePageChange">
								</Page>
							</div>
						</Col>
					</Row>
				</div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeName: "1",
			pageIndex: 1,   //頁數
			curPageSize: 10,    //一頁數量
			totalCount: 1, //總條數
			pageInput: '',  //輸入的頁碼
			samecityList: [],
			form: {
				keywords: '',
				is_shop: '',
			},
			company_name: 1,
			isLoading: true,
			table: {
				column: [
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 160
					},
					{
						title: '店櫃序號',
						key: 'cainiao_match',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '店櫃名稱',
						key: 'ReceivingName',
						align: 'center',
						sortable: true,
						minWidth: 150
					}, {
						title: '门店简称',
						key: 'ReceivingNameShort',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '公司',
						key: 'admin_names',
						sortable: true,
						align: 'center',
						minWidth: 100
					},
					{
						title: '直營店/加盟店',
						key: 'join',
						sortable: true,
						align: 'center',
						minWidth: 100
					},
					{
						title: '店櫃地址',
						key: 'ReceivingAddress',
						align: 'center',
						sortable: true,
						minWidth: 250
					},
					{
						title: '營業時間',
						key: 'time_description',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '(門店線下)立減3元',
						key: 'offline_activity',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '(手機APP線上)立減3元',
						key: 'activity',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '顯示在手機APP內',
						key: 'style_open',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '參加抽獎',
						key: 'is_lottery',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '設定為送貨上門',
						key: 'delivery',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '設定送貨上門的支付模式',
						key: 'delivery_default',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '設定24小時營業',
						key: 'do_type',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '設定好物對換',
						key: 'is_shop',
						sortable: true,
						align: 'center',
						minWidth: 200
					},
					{
						title: '刪除時間',
						key: 'deleted_at',
						sortable: true,
						align: 'center',
						minWidth: 200
					}
				],
				data: []
			}
		};
	},
	activated() {
		this.getSamcityList();
		this.getList(this.company_name);
	},
	created() {
		this.getSamcityList();
		this.getList(this.company_name);
	},
	methods: {
		handleClick(tab, event) {
			this.getList(tab.name, 1, 10);
		},
		getSamcityList() {
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get',
			}).then((res) => {
				if (res.code == 0) {
					this.samecityList = res.data.data;
				}
			});
		},
		getList(companyid, offset, limit) {
			if (limit != undefined) {
				this.curPageSize = limit;
			}
			if (offset != undefined) {
				this.pageIndex = offset;
			}
			if (companyid != undefined) {
				this.company_name = companyid;
			}
			let form = this.form;
			this.isLoading = true;
			this.$Rq.requestAuth({
				url: this.$Api.pickAddress,
				method: 'get',
				data: {
					// type: 1,  // 1门店，2智能柜
					company_id: this.company_name,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					keywords: form.keywords,
					is_shop: form.is_shop,
				}
			}).then((res) => {
				this.isLoading = false;
				if (res.code == 0) {
					let tempArr = [];
					let resData = res.data.data;
					
					for (let i = 0; i < resData.length; i++) {
						if (resData[i].join == 1) {
							resData[i].join = '加盟店';
						}
						if (resData[i].join == 0) {
							resData[i].join = '直營店';
						}
						
						if (resData[i].do_type === 2) {
							tempArr.push({
								ReceivingID: resData[i].ReceivingID,
								cainiao_match: resData[i].cainiao_match,
								ReceivingName: resData[i].ReceivingName == null ? '- - -' : resData[i].ReceivingName,
								ReceivingNameShort: resData[i].ReceivingNameShort == null ? '- - -' : resData[i].ReceivingNameShort,
								ReceivingAddress: resData[i].ReceivingAddress == null ? '- - -' : resData[i].ReceivingAddress,
								activity: resData[i].activity > 0 ? '有' : '沒有',
								// opeartion_time: '24小時',
								style_open: resData[i].style_open > 0 ? '有' : '沒有',
								time_description: resData[i].time_description,
								delivery: resData[i].delivery > 0 ? '有' : '沒有',
								delivery_default: resData[i].delivery_default == 1 ? '有' : '沒有',
								join: resData[i].join == null ? '- - -' : resData[i].join,
								offline_activity: resData[i].offline_activity > 0 ? '有' : '沒有',
								is_lottery: resData[i].is_lottery > 0 ? '有' : '沒有',
								deleted_at: resData[i].deleted_at == null ? '- - -' : resData[i].deleted_at,
								do_type: '有',
								is_shop: resData[i].is_shop > 0 ? '有' : '沒有',
								admin_names: resData[i].admin_names == null ? '- - -' : resData[i].admin_names.name,
							});
						} else {
							tempArr.push({
								ReceivingID: resData[i].ReceivingID,
								cainiao_match: resData[i].cainiao_match,
								ReceivingName: resData[i].ReceivingName == null ? '- - -' : resData[i].ReceivingName,
								ReceivingNameShort: resData[i].ReceivingNameShort == null ? '- - -' : resData[i].ReceivingNameShort,
								ReceivingAddress: resData[i].ReceivingAddress == null ? '- - -' : resData[i].ReceivingAddress,
								activity: resData[i].activity > 0 ? '有' : '沒有',
								// opeartion_time: resData[i].start_time == null ? '- - -' : resData[i].start_time.substring(0, resData[i].start_time.length - 3) + '-' + resData[i].end_time.substring(0, resData[i].end_time.length - 3),
								style_open: resData[i].style_open > 0 ? '有' : '沒有',
								time_description: resData[i].time_description,
								delivery: resData[i].delivery > 0 ? '有' : '沒有',
								delivery_default: resData[i].delivery_default == 1 ? '有' : '沒有',
								join: resData[i].join == null ? '- - -' : resData[i].join,
								offline_activity: resData[i].offline_activity > 0 ? '有' : '沒有',
								is_lottery: resData[i].is_lottery > 0 ? '有' : '沒有',
								deleted_at: resData[i].deleted_at == null ? '- - -' : resData[i].deleted_at,
								do_type: '沒有',
								is_shop: resData[i].is_shop > 0 ? '有' : '沒有',
								admin_names: resData[i].admin_names == null ? '- - -' : resData[i].admin_names.name,
							});
						}
					}
					
					this.totalCount = res.data.count;
					this.table.data = tempArr;
				}
			}).catch(() => {
				this.isLoading = false;
			});
		},
		handleToAdd() {
			this.$router.push({path: '/shopManageAdd'});
		},
		handleSearch() {
			this.pageIndex = 1;
			this.getList(this.company_name);
		},
		handleEdit(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/shopManageEdit?id=' + tableData[index].ReceivingID});
		},
		handleDelete(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定刪除嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.shopDelete + '/' + tableData[index].ReceivingID,
						method: 'delete'
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							if (tableData.length <= 1 && this.pageIndex > 1) {
								this.pageIndex -= 1;
							}
							
							this.getList(this.company_name);
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
					
				}
			});
		},
		handleRestore(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定還原嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.shopRestore + '/' + tableData[index].ReceivingID,
						method: 'post'
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							if (tableData.length <= 1 && this.pageIndex > 1) {
								this.pageIndex -= 1;
							}
							
							this.getList(this.company_name);
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
					
				}
			});
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList(this.company_name);
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList(this.company_name);
		},
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList(this.company_name);
		}
	}
};
</script>

<style lang="scss" scoped>
@import 'ShopManage.scss';
</style>
